import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { deleteBreachRecord } from '../../../../slices/breachRecord/thunk';
import { setRequireCloseModal } from '../../../../slices/breachRecord/reducer';

const DeleteIncumplimiento = ({
	dataIncumplimiento,
	isOpen,
	handleToggleModal,
	onDeleteSuccess,
}) => {
	const dispatch = useDispatch();

	const selectorBreachRecord = createSelector(
		state => state.BreachRecord,
		breachRecord => ({
			isDeleting: breachRecord?.isDeleting,
			isDeleted: breachRecord?.isDeleted,
			requireCloseModal: breachRecord?.requireCloseModal,
		})
	);

	const { isDeleting, isDeleted, requireCloseModal } = useSelector(selectorBreachRecord);

	useEffect(() => {
		if (isOpen && isDeleted && requireCloseModal) {
			dispatch(setRequireCloseModal(false));
			onDeleteSuccess?.();
			handleToggleModal();
		}
	}, [isDeleted, requireCloseModal]);

	const handleDelete = () => {
		if (dataIncumplimiento?._id) {
			dispatch(deleteBreachRecord(dataIncumplimiento));
		}
	};

	const previewText =
		dataIncumplimiento?.description || dataIncumplimiento?.incumplimiento || '';
	const incumplimientoPreview = previewText
		? previewText.substring(0, 50) + (previewText.length > 50 ? '...' : '')
		: '';

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={handleToggleModal}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un incumplimiento!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en confirmar.
						</p>
						{incumplimientoPreview && (
							<p className='small'>Incumplimiento: {incumplimientoPreview}</p>
						)}
						<div className='hstack gap-2 justify-content-center'>
							<Button
								className='btn-danger btn-label'
								onClick={handleToggleModal}
								disabled={isDeleting}
							>
								<i className='ri-close-line label-icon'></i>
								Cancelar
							</Button>
							<button
								className='btn btn-label btn-primary'
								onClick={handleDelete}
								disabled={isDeleting}
							>
								{isDeleting
									? <i className='label-icon'><Spinner size='sm' /></i>
									: <i className='ri-check-double-line label-icon'></i>
								}
								{' '}Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteIncumplimiento;

